export default __webpack_public_path__ + "static/media/cert-senior-manager-cpttm.069f4916.jpg";